<tr *transloco="let t">
  <td>
    {{ portfolioTarget.created | date : 'd. M. y' }}
  </td>
  <td>
    <div>{{ portfolioTarget.teacherFirstName }} {{ portfolioTarget.teacherLastName }}</div>
    <div>
      <span class="teacher-groups">{{ portfolioTarget.teacherGroups | formatTeacherGroups }}</span>
    </div>
  </td>
  <td>
    <span class="fw-bold">{{ portfolioTarget.title }}</span>
  </td>
  <td>
    <div class="target-state" [ngClass]="getTargetStateClass(portfolioTarget.state)">
      {{ targetStateData[portfolioTarget.state] }}
    </div>
  </td>
  <td>{{ supportTypeData[portfolioTarget.supportType] }}</td>
</tr>
